




















import {
  ContactLensImageType,
  loadContactLensImageTypeSwitcherHintDismissed,
  saveContactLensImageTypeSwitcherHintDismissed,
} from '@/services/contact-lens-image-type/contact-lens-image-type-storage'
import Vue, { PropType } from 'vue'

interface ImageTypeOption {
  readonly type: ContactLensImageType
  readonly label: string
}

/**
 * 一覧画像の種別を循環切替するボタン。
 * 既存商品一覧のContactLensImageTypeSwitcherと同じ見せ方(次に切り替わる種別のアイコンを表示)だが、
 * バンドルの方針(新フロント移植前提で既存UI・storeへ依存しない。index.tsのdocblock参照)により
 * 意図的に独立実装とする。
 */
const options: ImageTypeOption[] = [
  { type: 'worn', label: '着画で見る' },
  { type: 'lens', label: 'レンズで見る' },
  { type: 'package', label: 'モデルで見る' },
]

export default Vue.extend({
  props: {
    value: {
      type: String as PropType<ContactLensImageType>,
      required: true,
    },
  },
  data() {
    return {
      showHint: !loadContactLensImageTypeSwitcherHintDismissed(),
    }
  },
  computed: {
    nextOption(): ImageTypeOption {
      const currentIndex = options.findIndex(option => option.type === this.value)
      const safeIndex = currentIndex === -1 ? 0 : currentIndex

      return options[(safeIndex + 1) % options.length]
    },
  },
  methods: {
    onClick(): void {
      this.$emit('input', this.nextOption.type)
      // 一度でも切り替えたらヒントの役目は済んでいるため、以後は(既存一覧側も含め)出さない
      this.showHint = false
      saveContactLensImageTypeSwitcherHintDismissed()
    },
  },
})
